import Vue from 'vue'
import { MutationTree } from 'vuex/types/index'
import { GuestListsState, GuestListResource } from './guest-lists.types'

const mutations: MutationTree<GuestListsState> = {
  SET_GUEST_LIST (state, list: GuestListResource) {
    Vue.set(state.data, list.id, list)
  }
}

export default mutations
